import { useContext, useEffect } from "react";
import { ToolContext } from "../../../../context/ToolContext";
import { JoyrideWrapper } from "../JoyrideWrapper";

export const BranchWalkthrough = ({ pathname, end, start}) => {

    const {personalization_state} = useContext(ToolContext)
    const {walkthrough} = personalization_state

    const startTour = () =>{
        walkthrough.set((prev) => ({...prev, createBranch:true}))
    }

    const endTour = ()=>{
        walkthrough.set((prev) => ({...prev, createBranch:false}))
    }

    useEffect(() => {
        start("setup", "branch-setup", startTour)
        //eslint-disable-next-line
    }, []);

    const steps =[
            {
                content: "Insert Branch Code",
                placement: "right",
                target: "#walkthrough-branch-step-1",
                disableBeacon: true
            },
            {
                content: "Insert Branch Name  ",
                placement: "right",
                target: "#walkthrough-branch-step-2",
                disableBeacon: true
            },
            {
                content: "You can click the plus button to add more branch",
                placement: "right",
                target: "#walkthrough-branch-step-3",
                disableBeacon: true
            },
            {
                content: "Once done, click Save to create the branch",
                placement: "right",
                target: "#walkthrough-branch-step-4",
                disableBeacon: true
            },
        ]
        
    return (
        <JoyrideWrapper 
            run={walkthrough.data.createBranch && window.location.pathname === pathname} 
            steps={steps} 
            setter={endTour} 
            end={end}
            p_name="branch-setup" 
            featureName="setup"
        />
    );
}
